import React from 'react';
import './About.css';
import Headshot from '../../assets/headshot.jpg';
import Resume from '../../assets/JLeMoure_Resume.pdf';

const About = () => {
    const downloadResume = async () => {
        window.open(Resume, '_blank');
    }

    return (
        <section className="about container section" id="about">
            <h2 className="section__title">About Me </h2>

            <div className="about__container grid">
                <img src={Headshot} alt="Joseph LeMoure" className='about__img' />

                <div className="about__data grid">
                    <div className="about__info">
                        <p className="about__description">
                            Hi! I'm Joe, and I'm currently based in Boston, MA.<br /><br />
                            I'm a Full-stack Software Engineer with experience at seed and Series A startups, building fintech and real-estate platforms from 0 to 1. 
Skilled in designing and scaling RESTful APIs, developing web and iOS frontends, and managing CI/CD pipelines and cloud 
infrastructure. Focused on delivering secure, production-ready software in fast-paced environment.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About